// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"dfc5e9de","453":"46dc3e92","478":"251656d5","565":"b9c76bdd","594":"76d605e8","749":"0ffa0377","903":"15b81f5d","959":"2d688c59"}[chunkId] + ".chunk.js";
};